export default __webpack_public_path__ + "static/media/IBimagehiplock2.a0eb83dd.png";